import { formatEth, isoToEth } from '@assist/core';

/** A FHIR date or dateTime as an Ethiopian calendar date for display. */
export const eth = (iso: string) => {
  const e = isoToEth(iso.slice(0, 10));
  return e ? formatEth(e) : iso.slice(0, 10);
};
